import type React from 'react'
import type { JSX } from 'react'
import type { InputBlockMargin, InputBlockRowGap } from './InputBlock.h'

import { TextBoxCaption4Warning } from 'atoms/TextBox/Templates'
import { InputBlockRowGaps } from './InputBlock.h'
import { InputBlockStyled } from './InputBlock.styled'

export interface IInputBlockProps {
  children: React.ReactNode
  errorMessage?: string
  rowGap?: InputBlockRowGap
  width?: number
  margins?: InputBlockMargin
}

export const InputBlock = ({
  children,
  errorMessage = '',
  rowGap = InputBlockRowGaps.SIZE_0,
  width,
  margins,
}: IInputBlockProps): JSX.Element => (
  <InputBlockStyled rowGap={rowGap} width={width} margins={margins}>
    {children}
    {errorMessage && <TextBoxCaption4Warning title={errorMessage} />}
  </InputBlockStyled>
)
